



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class KpiCard extends Vue {
  @Prop({ default: "mdi-chart-bar" }) icon!: string;
  @Prop({ default: "primary" })       color!: string;
  @Prop({ default: "" })              label!: string;
  @Prop({ default: "" })              value!: string;
  @Prop({ default: "" })              tooltip!: string;
  @Prop({ default: false, type: Boolean }) clickable!: boolean;

  onClick() {
    if (this.clickable) {
      this.$emit("click");
    }
  }
}
